export const loadContributorReducer = (state = false, action) =>{
    switch (action.type) {
        case 'CONTRIBUTOR_LOAD':
                return state = action.payload
        default:
            return state
    }
}